import React from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

const ChargeboxesDialogDelete = (props) => (
	<Dialog
		onClose={props.handleClose}
		aria-labelledby="chargebox-dialog-delete-title"
		aria-describedby="chargebox-dialog-delete-description"
		open={props.open}
		fullWidth
		maxWidth="xs"
	>
		<DialogTitle id="chargebox-dialog-delete-title">
			<Translate id="chargeboxes.dialogs.delete.title" />
		</DialogTitle>
		<DialogContent>
			<DialogContentText id="chargebox-dialog-delete-description">
				<Typography>
					<Translate id="chargeboxes.dialogs.delete.text" />
				</Typography>
			</DialogContentText>
			<DialogContentText>
				<Typography>{`${props.chargebox.id} - ${props.chargebox.alias}`}</Typography>
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={props.handleClose} color="default" autoFocus>
				<Translate id="chargeboxes.dialogs.close" />
			</Button>
			<Button onClick={props.submit} color="primary">
				<Translate id="chargeboxes.dialogs.delete.submit" />
			</Button>
		</DialogActions>
	</Dialog>
);

export default withLocalize(ChargeboxesDialogDelete);
